<template>
    <div>
        <DxList
            ref="listRef"
            :data-source="data"
            :search-enabled="true"
            search-mode="contains"
            search-expr="name"
            selection-mode="single"
            focus-state-enabled="false"
            :min-search-length="2"
            @item-click="onItemClick"
            @selection-changed="onItemSelected"
            @content-ready="onContentReady"
        >
            <template #item="{ data }">
                <div class="list-item">{{ data.name }}</div>
            </template>
        </DxList>
    </div>
</template>

<script setup>
import { bridge } from '@/views/history/history-card/history-bridge';
import DxList from 'devextreme-vue/list';

import { inject, onMounted, ref } from 'vue';
import { api } from '@/service/http';

let last_selected_id = null;
let selected_id = null;

const data = ref([]);
const listRef = ref(null);
const userData = inject('userData');

onMounted(async () => {
    // console.log(':onMounted', bridge.dog_context);
    bridge.addUpdateControlCallback(setData);
    await initData();
});

const initData = async () => {
    try {
        const response = await api('core./history/ctx/filials/get', { for_dogs: true });
        data.value = response.items;
    } catch (error) {
        console.error('ctx-dog-orgs:initData error:', error.message);
        return {
            result: false,
            error: error.message,
            uuid: '552a7862-f5e5-485a-bd8e-850f24aafadc',
        };
    }
};

const setData = async changes => {
    // console.log('ctx-dog-orgs:setData dep_id=', changes.dog_ctx_dep_id);
    selected_id = changes.dog_ctx_dep_id;
};

const selectItemById = id => {
    if (id) {
        const selectedItem = data.value.find(item => item.id === id);
        listRef.value.instance.selectItem(selectedItem);
    }
};

const onItemClick = x => {
    if (last_selected_id === x.itemData.id) {
        x.component.unselectAll();
        last_selected_id = null;
    } else {
        last_selected_id = x.itemData.id;
    }
};

const onItemSelected = async x => {
    userData.value.dog_ctx_dep_id = x.addedItems.length > 0 ? x.addedItems[0].id : null;
    // сохранение контекста подразделения
    bridge.cardCallbacks.onChangeData(userData.value);
    // Вызов для обновления списка договоров в контексте подразделения
    await bridge.onChangeDepInDogContext(userData.value.dog_ctx_dep_id);
};

const onContentReady = () => {
    if (data.value?.length > 0) {
        selectItemById(selected_id);
    }
};
</script>

<style scoped>
.list-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.list-item:hover {
    background-color: #f5f5f5;
}

.selected-item {
    margin-top: 20px;
    padding: 10px;
    background-color: #e3f2fd;
    border-radius: 4px;
}
</style>
